import React, {Component, useState, useContext, useEffect} from "react";
import Dropdown from 'react-dropdown';
import {useTranslation} from 'react-i18next';
import './RulesTableStyles.scss';
import GlobalRulesContext from './RulesContext';
import {StatementNode, ConditionNode, AddNode, getNodeById} from './RulesData';
import { v4 as uuid } from 'uuid';

const AddRuleNode = (props) => {
		const [t] = useTranslation();
		const addNodeTypes = [
			{value: "add_statement", label: t("views.interview.rules_editor.add_statement")},
			{value: "add_condition", label: t("views.interview.rules_editor.add_condition")}
		];

		let {rules, updateRules} = useContext(GlobalRulesContext);
		let currentNode = props.nodeInfo;//getNodeById(rules[0], props.nodeInfo.id);

		const onTypeSelected = (selection: any) => {
			if (selection.value && selection.value.length > 0) {
				let parentNode = null;
				if (currentNode.parent) {
					parentNode = currentNode.parent;
				}
				let node;
				if (selection.value == "add_statement") {
					node = new StatementNode(uuid(), "", null, "");
				} else if (selection.value == "add_condition") {
					node = new ConditionNode(uuid(), null );
					let addNode = new AddNode(uuid(), "");
					node.addChild(addNode);
				}
				if (parentNode) {
					parentNode.addChild(node);
				}
				currentNode.addNodeType = "";
				updateRules(rules, node.id);
			}
		};

		useEffect(() => {
			console.log("i am updated ---- AddNode ----");
		 },[rules]);

    return (
        <div className="single-line-container">
			<Dropdown
				onChange={onTypeSelected} 
				options={addNodeTypes}
				value={t('views.interview.rules_editor.add')}
				placeholder={t('views.interview.rules_editor.add')} />
        </div>
    );
}

export default AddRuleNode;